import React from 'react';
import Popup from 'reactjs-popup';

interface TooltipProps {
	trigger?: any;
	position?: string;
	children?: any;
	customStyle?: object;
}

export default function Tooltip(props: TooltipProps) {
	const { trigger, position, customStyle, children } = props;

	const contentStyle = {
		background: '#062a60',
		padding: '8px 6px',
		fontSize: '12px',
		fontFamily: 'Rubik',
		color: '#fff',
		borderRadius: '4px',
		maxWidth: '300px',
	};
	const overlayStyle = { background: 'rgba(0,0,0,0.5)' };
	const arrowStyle = { color: '#062a60' }; // style for an svg element

	return (
		<Popup
			trigger={<div style={customStyle}>{trigger}</div>}
			position={position}
			on={'hover'}
			{...{ contentStyle, overlayStyle, arrowStyle }}
		>
			{children}
		</Popup>
	);
}
